module.exports = __webpack_public_path__ + "static/get-ready-3-8e1e405116fa168324965eb35757b782.png";